import { AlertFactory } from 'alerts/Alert'
import ProviderStore from 'iam/ProviderStore'
import ProDetailsViewModel from 'iam/pro-details/ProDetailsViewModel'
import ModalViewModel from 'infra/ModalViewModel'
import { action, makeObservable, observable } from 'mobx'
import { task } from 'mobx-task'
import { Id } from 'types/definitions'

export class EditProDetailsDialogViewModel extends ModalViewModel {
  @observable details: ProDetailsViewModel | null = null

  constructor(
    private newAlert: AlertFactory,
    private providerStore: ProviderStore,
  ) {
    super()
    makeObservable(this)
  }

  @action.bound
  open(userPublicId: Id) {
    this.details = new ProDetailsViewModel(
      this.newAlert,
      this.providerStore,
      userPublicId,
      true,
    )
    this.show()
  }

  submit = task.resolved(async () => {
    if (!this.details) {
      return
    }
    const saved = await this.details.save()
    if (saved) {
      this.close()
    }
  })
}
